var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-overlay",
            { attrs: { value: _vm.loaderOverlay, absolute: true } },
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "64" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-title",
            { staticClass: "row no-gutters justify-start" },
            [
              _c("v-icon", { staticClass: "pr-2" }, [
                _vm._v("mdi-account-supervisor-outline"),
              ]),
              _c("h3", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.$t("userAdministration"))),
              ]),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { "align-content": "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-text-field",
                        {
                          staticStyle: { "border-radius": "2em / 5em" },
                          attrs: {
                            label: _vm.$t("search"),
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.userListSearch,
                            callback: function ($$v) {
                              _vm.userListSearch = $$v
                            },
                            expression: "userListSearch",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "prepend" },
                            [
                              _vm.userListSearch == ""
                                ? _c("v-icon", [_vm._v("mdi-magnify")])
                                : _vm._e(),
                              _vm.userListSearch != ""
                                ? _c(
                                    "v-icon",
                                    {
                                      style: { cursor: "pointer" },
                                      attrs: { color: "primary " },
                                      on: {
                                        click: function ($event) {
                                          _vm.userListSearch = ""
                                        },
                                      },
                                    },
                                    [_vm._v("mdi-cached")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "3" } }, [
                    _c(
                      "div",
                      [
                        _c("v-switch", {
                          staticClass: "mt-2",
                          attrs: {
                            label: !_vm.showInactiveUser
                              ? _vm.$t("showInactiveUser")
                              : _vm.$t("hideInactiveUser"),
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.showInactiveUser,
                            callback: function ($$v) {
                              _vm.showInactiveUser = $$v
                            },
                            expression: "showInactiveUser",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-data-table", {
                    key: _vm.refreshTable,
                    staticClass: "elevation-1 table-header",
                    staticStyle: { width: "100%" },
                    attrs: {
                      headers: _vm.userListHeaders,
                      items: _vm.filteredUserList,
                      search: _vm.userListSearch,
                      "item-key": "name",
                      "items-per-page": _vm.userPerPage,
                      "show-select": "",
                    },
                    on: { "update:items-per-page": _vm.getItemPerPage },
                    scopedSlots: _vm._u([
                      {
                        key: "header.data-table-select",
                        fn: function ({ on, props }) {
                          return [
                            false
                              ? _c(
                                  "v-simple-checkbox",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: { "hide-details": "" },
                                        on: {
                                          input: function ($event) {
                                            _vm.selectAllUser(),
                                              _vm.userSelected()
                                          },
                                        },
                                      },
                                      "v-simple-checkbox",
                                      props,
                                      false
                                    ),
                                    on
                                  )
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item",
                        fn: function ({ item, select, isSelected }) {
                          return [
                            _c("tr", { style: _vm.setStyle(item) }, [
                              _c("td"),
                              _c(
                                "td",
                                { staticClass: "pa-0" },
                                [
                                  _vm._v(" " + _vm._s(item.name) + " "),
                                  item.teams &&
                                  item.SAPEmpID != "0000" &&
                                  item.teams.length === 0
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            color: "primary",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "primary--text",
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "mdi-exclamation-thick"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          item.notInSAP === true
                                            ? _c("span", {}, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("userInSAPNotFound")
                                                  )
                                                ),
                                              ])
                                            : item.activeInSAP === true
                                            ? _c("span", {}, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("userHasNoTeam")
                                                  )
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "employeeIsInactiveInSAP"
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("td", { staticClass: "pa-0" }, [
                                _vm._v(" " + _vm._s(item.usercode) + " "),
                              ]),
                              _c("td", { staticClass: "pa-0" }, [
                                _vm._v(" " + _vm._s(item.teamNames) + " "),
                              ]),
                              _c(
                                "td",
                                { staticClass: "pa-0" },
                                [
                                  _c("v-autocomplete", {
                                    staticStyle: { width: "150px" },
                                    attrs: {
                                      items: _vm.managerUserList,
                                      "item-text": "name",
                                      "item-value": "SAPEmpID",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.managerChanged(item)
                                      },
                                    },
                                    model: {
                                      value: item.manager,
                                      callback: function ($$v) {
                                        _vm.$set(item, "manager", $$v)
                                      },
                                      expression: "item.manager",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "pa-0" },
                                [
                                  _c("v-autocomplete", {
                                    staticStyle: { width: "150px" },
                                    attrs: {
                                      items: _vm.managerUserList,
                                      "item-text": "name",
                                      "item-value": "SAPEmpID",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.managerChanged(item)
                                      },
                                    },
                                    model: {
                                      value: item.representative,
                                      callback: function ($$v) {
                                        _vm.$set(item, "representative", $$v)
                                      },
                                      expression: "item.representative",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("td", { staticClass: "pa-0" }, [
                                _vm._v(" " + _vm._s(item.timeModelName) + " "),
                              ]),
                              _c(
                                "td",
                                { staticClass: "pa-0" },
                                [
                                  _c("v-select", {
                                    staticStyle: { width: "120px" },
                                    attrs: {
                                      items: _vm.states,
                                      "item-text": "name",
                                      "item-value": "code",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.stateChanged(item)
                                      },
                                    },
                                    model: {
                                      value: item.state,
                                      callback: function ($$v) {
                                        _vm.$set(item, "state", $$v)
                                      },
                                      expression: "item.state",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { "justify-center": "" } },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            color: "primary",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return item.active == 1
                                                    ? [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.changePassword(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-lock-reset"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    : undefined
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", { staticClass: "px-1" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("resetPassword"))
                                            ),
                                          ]),
                                        ]
                                      ),
                                      item.SAPEmpID != "0000" &&
                                      item.active == 1
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                color: "primary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showEditUserOverlay(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-pencil"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              item.SAPEmpID != "0000" &&
                                              item.active == 1
                                                ? _c(
                                                    "span",
                                                    { staticClass: "pr-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("edit"))
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      item.SAPEmpID != "0000" &&
                                      item.active == 1
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                color: "primary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.dialogRFID =
                                                                      !_vm.dialogRFID
                                                                    _vm.selectedUser =
                                                                      item
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    _vm.setRFIDColor(
                                                                      item.rfid
                                                                    ),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-access-point"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", {}, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("RFIDRegistration")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      item.SAPEmpID != "0000" &&
                                      item.active == 1 &&
                                      item.rfid
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                color: "primary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.resetRFID(
                                                                      item.SAPEmpID
                                                                    )
                                                                    _vm.selectedUser =
                                                                      item
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color: "red",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-access-point-remove"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", {}, [
                                                _vm._v(
                                                  _vm._s(_vm.$t("RFIDReset"))
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      item.SAPEmpID != "0000" &&
                                      item.active == 1
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                color: "primary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteUsers(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-delete"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", {}, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("deactivateUser")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      item.active == 0
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                color: "primary",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.activateUser(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-account-check"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", {}, [
                                                _vm._v(
                                                  _vm._s(_vm.$t("activateUser"))
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selectedTasks,
                      callback: function ($$v) {
                        _vm.selectedTasks = $$v
                      },
                      expression: "selectedTasks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "justify-end pa-0 ma-0" },
            [
              _c(
                "v-btn",
                {
                  staticClass:
                    "font-weight-medium buttonHoverOpacity pa-6 mt-2 mr-4 mb-4",
                  staticStyle: { color: "white" },
                  attrs: { rounded: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.importUsersButton()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("sapImport")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.userEditDialogModel
        ? _c("EditUser", {
            attrs: {
              User: _vm.userToEdit,
              selected: _vm.userToEdit.selectedGroups,
            },
            on: {
              close: function ($event) {
                return _vm.editUserClose()
              },
            },
          })
        : _vm._e(),
      _vm.sapDialogModel
        ? _c("SapUserImport", {
            attrs: { importedUsersList: _vm.userList },
            on: {
              close: function ($event) {
                _vm.sapDialogModel = false
                _vm.getUsers()
              },
            },
          })
        : _vm._e(),
      _vm.userPasswordChangeDialog
        ? _c("ResetPassword", {
            attrs: { newpasswordonlogin: true, empid: _vm.userToEdit.SAPEmpID },
            on: {
              finished: function ($event) {
                _vm.userPasswordChangeDialog = false
              },
            },
          })
        : _vm._e(),
      _vm.dialogRFID
        ? _c("RFIDRegistration", {
            attrs: { userId: _vm.selectedUser.SAPEmpID, saveMode: true },
            on: {
              close: function ($event) {
                ;(_vm.dialogRFID = false), _vm.getUsers()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }